import { UIBrandedFare, UIBrandedFareFeature } from "@flights/types";
import { getFeaturesToRender } from "./features";
import { CHANGE_FEATURES } from "@flights/branded-fares";

export const isBaseFare = (fareToken: string, brandedFareOffers: UIBrandedFare[]): boolean => {
  return findFareIndex(fareToken, brandedFareOffers) === 0;
};

export const findFareIndex = (fareToken: string, brandedFareOffers?: UIBrandedFare[]): number | undefined => {
  if (!brandedFareOffers) return;

  const index = brandedFareOffers.findIndex((offer) => offer.token === fareToken);

  return index < 0 ? undefined : index;
};

export const getFareWithName = (brandedFareOffers: UIBrandedFare[], fareName: string): UIBrandedFare | undefined =>
  brandedFareOffers.find((offer) => offer.brandedFareInfo.fareName === fareName);

export const hasChangeFeatures = (brandedFareOffers: UIBrandedFare[]): boolean =>
  brandedFareOffers.some((offer) =>
    getFeaturesToRender(offer.brandedFareInfo).includedFeatures.some((feature) =>
      CHANGE_FEATURES.includes(feature.featureName)
    )
  );

export const hasExcludedCheckedBaggage = (brandedFareOffers: UIBrandedFare[], isPreCheckAndPay: boolean): boolean =>
  brandedFareOffers.some((offer) =>
    getFeaturesToRender(offer.brandedFareInfo, {
      includeExcludedFeatures: true,
      isPreCheckAndPay
    }).nonIncludedFeatures.some((feature) => feature.featureName === "CHECK_BAGGAGE")
  );

export const getUniqueUpsellFeatures = (brandedFareOffers: UIBrandedFare[]) => {
  if (brandedFareOffers.length < 2) return [];

  const [baseFare, popularFare] = brandedFareOffers;
  const getIncludedKey = (f: UIBrandedFareFeature) =>
    ["CHECK_BAGGAGE", "PERSONAL_BAGGAGE", "CABIN_BAGGAGE"].includes(f.featureName) ? f.label : f.featureName;

  const baseIncludedFeatures = new Set(baseFare.brandedFareInfo.features.map(getIncludedKey));
  const baseSellableFeatures = new Set(baseFare.brandedFareInfo.sellableFeatures?.map((f) => f.featureName) ?? []);

  return [
    ...popularFare.brandedFareInfo.features.filter((feature) => !baseIncludedFeatures.has(getIncludedKey(feature))),
    ...(popularFare.brandedFareInfo.sellableFeatures?.filter(
      (feature) => !baseSellableFeatures.has(feature.featureName)
    ) ?? [])
  ];
};
